<template>
    <div class="wrap-content">
        <div class="content">
            <table>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Owner</th>
                        <th scope="col">Dimension(mm<sup>3</sup>)</th>
                        <th scope="col">Fineness</th>
                        <th scope="col">Hallmark</th>
                        <th scope="col">Weight (gr)</th>
                        <th scope="col">Serial Number</th>
                        <th scope="col">Year</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(detailHistory, index) in setDataHistory" :key="index" v-show="setDataHistory.length > 0">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td>{{ detailHistory.owner }}</td>
                        <td>{{ detailHistory.dimension }}</td>
                        <td>{{ detailHistory.fineness }}</td>
                        <td>{{ detailHistory.hallmark }}</td>
                        <td>{{ detailHistory.weight }}</td>
                        <td>{{ detailHistory.serial_number }}</td>
                        <td>{{ detailHistory.year }}</td>
                    </tr>
                    <tr>
                        <td colspan="8" v-show="setDataHistory.length == 0">Data Not Found</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-3">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="setTotalDetailHistory"
                    :per-page="perPage"
                    @change="handlePageChange"
                    aria-controls="new-table"
                    first-number
                    last-number
                    v-show="setTotalDetailHistory > 10"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        historyId: String,
        setDataHistory: Array,
        setTotalDetailHistory: Number,
    },
    data() {
        return {
            startDate: "",
            endDate: "",
            currentPage: 1,
            perPage: 10,
            id_ijin: "",
            idHistory: this.historyId,
        };
    },
    created() {
        this.$store.dispatch("getHistoryDetailRealitation", { history_id: this.historyId, currentPage: this.currentPage, perPage: this.perPage });
    },
    computed: {
        computedHistoryId: {
            get() {
                return this.historyId;
            },
            set(newValue) {
                this.$emit("historyIdChanged", newValue);
            },
        },
        getDetailHistory() {
            return this.$store.state.vaultModul.dataHistory.data;
        },
        totalRealitationsData() {
            return this.$store.state.vaultModul.dataHistory.count;
        },
    },
    watch: {
        historyId() {
            this.newHistoryId(this.historyId);
        },
    },
    methods: {
        newHistoryId(newValue) {
            this.idHistory = newValue;
            console.log(newValue);
        },
        handlePageChange(value) {
            // this.$store.dispatch("getHistoryDetailRealitation", { history_id: this.historyId, currentPage: value, perPage: this.perPage });
            let dataParse = {
                currentPage: value,
                perPage: this.perPage,
            };
            this.$emit("changePage", dataParse);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}
</style>
